// extracted by mini-css-extract-plugin
module.exports = {"wrraperMenu":"Menu_wrraperMenu__1LHS6","hamburgerClose":"Menu_hamburgerClose__8v6M7","containerItemsMenu":"Menu_containerItemsMenu__15RW3","itemsMenu":"Menu_itemsMenu__37N9u"};